import { useSetModal } from "@/shared/atoms/useModal";
import Icon from "../Icon/Icon";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";

const ReplyViaEmail = ({ order }: { order: OrderV2 }) => {
  const setModal = useSetModal();
  return (
    <span onClick={() => setModal("replyViaEmail", { order })} className="cursor-pointer">
      <Icon className="h-7 w-7 fill-primary" variants="envelope" />
    </span>
  );
};

export default ReplyViaEmail;
